module.exports = "/assets/data/f3071f7f9719af937e319a69c166d466-BT48.data.json";